import React, { Component } from "react";
import { connect } from "react-redux";

import { panelActions } from "../../actions";

class Item extends Component {
  handleKindClick(value) {
    this.props.dispatch(panelActions.setKind(value));
  }

  render() {
    let activeClass = "";
    let activeText = ""
    if (this.props.panelStorage.isKindActive(this.props.value)) {
      activeClass = " active";
      activeText = " aktiviert";
    }
    return (
      <button type="button"
        className={"ser-filterbut ser-iblock" + activeClass}
        onClick={this.handleKindClick.bind(this, this.props.value)}
        aria-label={"Metallart: " + this.props.name + activeText}
      >
        <span>{this.props.name}</span>
      </button>
    );
  }
}
export default connect(store => {
  return {
    panelStorage: store.panelStorage
  };
})(Item);
